<template>
    <div class="container login py-5 mt-5">
        <div class="row justify-content-center">
            <div class="card col-12 col-sm-10 col-md-8 col-lg-6 py-3 px-1 px-sm-2 px-md-3 shadow mb-5">

                <div class="row justify-content-center">
                    <div v-if="paymentType === 'Vipps'" class="col-6 col-md-4 mb-3 align-self-center">
                        <img :src="$window.enforceCDN('/tabselev/img/vipps-logo-orange.png')" alt="Vipps logo" class="img-fluid m-auto d-block">
                    </div>
                    <div v-else>
                        Generic payment type
                    </div>
                    <div class="text-center col-12" v-show="loading">
                        <span class="spinner-border" role="status"></span>
                    </div>
                </div>

                <div class="row" v-show="htmlResponse">
                    <div class="col-12" v-html="htmlResponse">
                    </div>
                </div>
                <PaymentForm v-if="showForm"
                             :paymentData="paymentData"
                             :paymentHash="paymentHash"
                             @inprogress="showResponse"
                             @error="handleError"></PaymentForm>
            </div>
        </div>

    </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import Api from '../../api/Payment';
import PaymentForm from './PaymentForm.vue';

const props = defineProps(['paymenthash', 'paymenttype', 'forcestatus']);
const paymentHash = ref(props.paymenthash);
const paymentType = ref(props.paymenttype);
const forceStatus = ref(props.forcestatus);
const showForm = ref(false);
const inprogress = ref(false);
const loading = ref(false);
const htmlResponse = ref('');
const paymentData = ref({});

const showResponse = (payload) => {
    inprogress.value = true;
    showForm.value = false;
    if ("showForm" in payload) {
        showForm.value = payload.showForm;
    }
};

const handleError = (error) => {
    htmlResponse.value = error;
    inprogress.value = false;
    showForm.value = false;
};

onMounted(() => {
    loading.value = true;
    Api.GetPaymentNoSessionTransaction(paymentHash.value, forceStatus.value).then(res => {
        loading.value = false;
        if (res.inprogress) {
            inprogress.value = true;
        }
        if (res.data) {
            paymentData.value = res.data;
            showForm.value = true;
            return;
        }
        htmlResponse.value = res.html;
    });
});
</script>
